import { arabicMessages } from './common';
export default { arabicMessages };
